import { RedesignGridBackground } from 'root/src/client/v2/layout/features/RedesignLayout/RedesignGridBackground';
import { RedesignLogo } from 'root/src/client/v2/layout/components/RedesignLogo';
// Page shell for the error surfaces that cannot lean on the app shell: `/500` (which `_app` renders
// bare, before any provider is mounted) and the ErrorBoundary fallback (which replaces the subtree
// that just threw). It therefore mounts NO RedesignLayout / RedesignNavbar on purpose: the navbar
// reads tRPC and redux state, which on an error screen is exactly what may have blown up.
//
// What it does keep is the redesign look: the `.redesign` token scope, the background, the ambient
// grid backdrop, and a logo that gets the user out. Pages with working providers (the 404) use the
// real RedesignLayout instead.
//
// The logo is a plain <a> (a full document navigation), never next/link, because `/` server-side
// redirects to the Webflow marketing site and a client-side transition would only fetch the Next data
// route for it and break.
export const RedesignStandaloneErrorShell = ({ children }) => (<div className="redesign isolate flex min-h-screen flex-col bg-background text-foreground">
		<RedesignGridBackground />
		<header className="px-4 py-5 sm:px-6">
			<a href="/" className="inline-flex no-underline" aria-label="Dare Drop home">
				<RedesignLogo />
			</a>
		</header>
		<main className="mx-auto flex w-full max-w-xl flex-1 items-center px-4 pb-16 sm:px-6">
			{children}
		</main>
	</div>);
